module.exports = __webpack_public_path__ + "img/p35.0f908a12.jpg";